var tablet_break = 900;
var max_wrap = 1200;
var bank_name = "Fidelity Deposit and Discount Bank";
